import axios from "axios";

export const getHereAccounts = () => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/HereDotCom/getAccounts")
    .then((res) => res.data);
};

export const addHereAccount = (newAccount) => {
  return axios
    .post(import.meta.env.VITE_BACKEND_API + "/api/HereDotCom/addAccount/", newAccount)
    .then((res) => res.data);
};

export const editHereAccount = (account) => {
  var betaClientIds = [];
  if (account.ClientHereDotComBetaAccounts?.length > 0) {
    betaClientIds = account.ClientHereDotComBetaAccounts.map((acc) => {
      return acc.id;
    });
  }
  var prodClientIds = [];
  if (account.ClientHereDotComProductionAccounts?.length > 0) {
    prodClientIds = account.ClientHereDotComProductionAccounts.map((acc) => {
      return acc.id;
    });
  }

  return axios
    .put(import.meta.env.VITE_BACKEND_API + "/api/HereDotCom/editAccount/", account, {
      headers: {
        "Content-Type": "application/json",
        client: betaClientIds.concat(prodClientIds),
      },
    })
    .then((res) => res.data);
};

export const deleteHereAccount = (account) => {
  var betaClientIds = [];
  if (account.ClientHereDotComBetaAccounts?.length > 0) {
    betaClientIds = account.ClientHereDotComBetaAccounts.map((acc) => {
      return acc.id;
    });
  }
  var prodClientIds = [];
  if (account.ClientHereDotComProductionAccounts?.length > 0) {
    prodClientIds = account.ClientHereDotComProductionAccounts.map((acc) => {
      return acc.id;
    });
  }

  return axios
    .delete(
      import.meta.env.VITE_BACKEND_API + "/api/HereDotCom/deleteAccount/" + account.Id,
      {
        headers: {
          "Content-Type": "application/json",
          client: betaClientIds.concat(prodClientIds),
        },
      }
    )
    .then((res) => res.data);
};
